<template>
    <table class="table rate-table">
        <thead>
        <tr>
            <th colspan="2">Rental Information</th>
        </tr>
        </thead>
        <tbody>
        <tr>
            <td><strong>Rental Location:</strong></td>
            <td>{{ config.site_name }}</td>
        </tr>
        <tr v-if="reservation.date_pickup!==null && reservation.date_return!==null">
            <td><strong>Rental Dates:</strong></td>
            <td>{{ rental_dates_formatted }}</td>
        </tr>
        <tr>
            <td><strong>Ski Rental<span v-if="reservation.date_pickup!==null && reservation.date_return!==null && !reservation.is_seasonal"> ({{ rental_timespan }})</span>:</strong></td>
            <td>{{ _money(cost.total_packages_price) }}</td>
        </tr>
        <tr>
            <td><strong>Add-on Total:</strong>
            </td>
            <td>{{ _money(cost.total_addon_price) }}</td>
        </tr>
        <tr v-if="is_buddy_service_enabled && cost.total_addon_price_buddy_insurance">
            <td><strong>Buddy Price:</strong></td>
            <td>{{ _money(cost.total_addon_price_buddy_insurance) }}</td>
        </tr>
        <tr v-if="cost.special_days_amount">
            <td><strong>Special period increase ( {{ cost.special_period_days_count }} Days):</strong></td>
            <td>{{ _money(cost.special_days_amount) }}</td>
        </tr>
        <tr>
            <td><strong>Sub Total:</strong></td>
            <td>{{ _money(cost.sub_total) }}</td>
        </tr>
        <tr v-if="cost.saved_by_coupon > 0">
            <td><strong>Discount:</strong></td>
            <td class="red--text">{{ _money(cost.saved_by_coupon) }}</td>
        </tr>
        <tr v-if="cost.book_me_discount && cost.book_me_discount.discount > 0">
            <td><strong>{{ cost.book_me_discount.name }} Discount({{ cost.book_me_discount.percentage }}%):</strong>
            </td>
            <td class="red--text">{{ _money(cost.book_me_discount.discount) }}</td>
        </tr>
        <template v-if="is_international_canadian">
            <tr>
                <td><strong>Tax: ( PST: {{sales_tax_pst}}% )</strong></td>
                <td>{{ _money(cost.pst_tax_amount) }}</td>
            </tr>
            <tr>
                <td><strong>Tax: ( GST: {{sales_tax_gst}}% )</strong></td>
                <td>{{ _money(cost.gst_tax_amount) }}</td>
            </tr>
        </template>
        <template v-else>
            <tr>
                <td><strong>Tax: ( {{  cost.tax_percent }}% )</strong></td>
                <td>{{ _money(cost.tax_amount) }}</td>
            </tr>
        </template>

        <tr v-if="parseInt(config.special_fee_at_checkout) == 1">
            <td><strong>{{config.special_fee_label}}:</strong></td>
            <td>{{ _money(cost.special_fee) }}</td>
        </tr>
        <tr>
            <td><strong><template v-if="securitydeposit && reservation.is_seasonal && frontend_view_folder == 'frontend.highcountryskiandtennis'">Total Rental</template><template v-else>Total Cost</template> <span v-if="!isNaN(rental_timespan)"> ({{ rental_timespan }})</span>:</strong></td>
            <td>{{ _money(cost.total_price - cost.deposit_total ) }}</td>
        </tr>
        <template v-if="securitydeposit && reservation.is_seasonal && frontend_view_folder == 'frontend.highcountryskiandtennis'">
            <tr>
                <td><strong>Deposit:</strong></td>
                <td>{{ _money( cost.deposit_total ) }}</td>
            </tr>
            <tr>
                <td><strong>Total:</strong></td>
                <td>{{ _money( cost.total_price ) }}</td>
            </tr>
        </template>
        </tbody>
    </table>
</template>

<script>
import moment from 'moment';
import {formatMoney} from "../../../../plugins/utils";
import UiManagerMixin from "../../../../mixins/UiManagerMixin";

export default {
    name: "RentalInformation",
    mixins  : [UiManagerMixin],
    methods:{
        _money(val){
            return formatMoney(val);
        }
    },
    computed: {
        rental_dates_formatted() {
            return moment(this.reservation.date_pickup).format(this.$store.state.config.dateFormat)
                + " - " + moment(this.reservation.date_return).format(this.$store.state.config.dateFormat);
        },
        rental_timespan() {
            const days = moment(this.reservation.date_return).diff(moment(this.reservation.date_pickup), 'days') + 1;
            return days + ' Day' + (days > 1 ? 's' : '');
        },
        reservation() {
            return this.$store.state.model.reservation;
        },
        rental_location() {
            return 'Rezo Ski Demo';
        },
        config() {
            return this.$store.state.resources.config;
        },
        cost() {
            return this.$store.state.model.cost;
        },
        special_fixed_fee() {
            return this.$store.state.model.reservees.length * parseFloat(this.config.special_fixed_fee).toFixed(2);
        },
        is_buddy_service_enabled() {
            let isBuddyChosen = false;
            if(this.$store.state.resources.config.is_buddy_service_enabled) {
                for(let i=0; i < this.$store.state.model.reservees.length; i ++) {
                    if (this.$store.state.model.reservees[i].addons.includes(parseInt(this.$store.state.resources.config.buddy_addon_id))) {
                        isBuddyChosen = true;
                    }
                }
            }

            return isBuddyChosen;
        },
        buddy_addon_id(){
            return this.$store.state.resources.config.buddy_addon_id;
        },
        securitydeposit(){
            return this.$store.state.resources.config.securitydeposit;
        },
        frontend_view_folder() {
            return this.$store.state.resources.config.frontend_view_folder;
        },
        is_international_canadian(){
            return parseInt(this.$store.state.resources.config.is_international_canadian);
        },
        sales_tax_pst(){
            return parseFloat(this.$store.state.resources.config.sales_tax_pst).toFixed(1);
        },
        sales_tax_gst(){
            return parseFloat(this.$store.state.resources.config.sales_tax_gst).toFixed(1);
        }
    }
}
</script>

<style scoped>

</style>
